/*
 * topical-prescription-product (schema)
 *
 * Join table linking a topical prescription to its selected products.
 */
import { boolean, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { topicalPrescriptions } from "../topical-prescription/topical-prescription.schema"
import { products } from "../product/product.schema"

export const topicalPrescriptionProducts = schema.table("topical_prescription_products", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	topicalPrescriptionId: uuid("topical_prescription_id")
		.notNull()
		.references(() => topicalPrescriptions.id, { onDelete: "cascade" }),
	productId: uuid("product_id")
		.notNull()
		.references(() => products.id, { onDelete: "cascade" }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
